"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var EstateMapAction;
(function (EstateMapAction) {
    EstateMapAction.ESTATE_MAP_ON_CANCEL = 'ESTATE_MAP_ON_CANCEL';
    EstateMapAction.ESTATE_MAP_ON_MAP_READY = 'ESTATE_MAP_ON_MAP_READY';
    EstateMapAction.ESTATE_MAP_ON_VIEWPORT_CHANGED = 'ESTATE_MAP_ON_VIEWPORT_CHANGED';
    EstateMapAction.ESTATE_MAP_ON_PIN_CLICKED = 'ESTATE_MAP_ON_PIN_CLICKED';
    EstateMapAction.onCancel = typesafe_actions_1.createAction(EstateMapAction.ESTATE_MAP_ON_CANCEL, function (resolve) { return function () { return resolve(); }; });
    EstateMapAction.onMapReady = typesafe_actions_1.createAction(EstateMapAction.ESTATE_MAP_ON_MAP_READY, function (resolve) { return function () { return resolve(); }; });
    EstateMapAction.onViewportChanged = typesafe_actions_1.createAction(EstateMapAction.ESTATE_MAP_ON_VIEWPORT_CHANGED, function (resolve) { return function () { return resolve(); }; });
    EstateMapAction.onPinClick = typesafe_actions_1.createAction(EstateMapAction.ESTATE_MAP_ON_PIN_CLICKED, function (resolve) { return function (i) { return resolve(i); }; });
})(EstateMapAction || (EstateMapAction = {}));
exports.default = EstateMapAction;
